export const DECORATED_CLASSS_TYPE = {
  class_type_id: '1002',
  class_type_name: 'Decorated'
};

export const classTypes = [
  {
    class_type_id: '1003',
    class_type_name: 'Alternate'
  },
  {
    class_type_id: '4004',
    class_type_name: 'ArtTemplate'
  },
  {
    class_type_id: '1001',
    class_type_name: 'Blank'
  },
  {
    class_type_id: '1012',
    class_type_name: 'Bottom'
  },
  {
    class_type_id: '4003',
    class_type_name: 'Compliance'
  },
  {
    class_type_id: '1005',
    class_type_name: 'Custom'
  },
  {
    class_type_id: '1002',
    class_type_name: 'Decorated'
  },
  {
    class_type_id: '4002',
    class_type_name: 'Facts'
  },
  {
    class_type_id: '1007',
    class_type_name: 'Front'
  },
  {
    class_type_id: '2001',
    class_type_name: 'High'
  },
  {
    class_type_id: '1013',
    class_type_name: 'Inside'
  },
  {
    class_type_id: '1010',
    class_type_name: 'Left'
  },
  {
    class_type_id: '500',
    class_type_name: 'Logo'
  },
  {
    class_type_id: '4005',
    class_type_name: 'Marketing'
  },
  {
    class_type_id: '1014',
    class_type_name: 'Outside'
  },
  {
    class_type_id: '3000',
    class_type_name: 'Podcast'
  },
  {
    class_type_id: '1006',
    class_type_name: 'Primary'
  },
  {
    class_type_id: '4001',
    class_type_name: 'ProductSafety'
  },
  {
    class_type_id: '1008',
    class_type_name: 'Rear'
  },
  {
    class_type_id: '1009',
    class_type_name: 'Right'
  },
  {
    class_type_id: '4000',
    class_type_name: 'Specs'
  },
  {
    class_type_id: '2000',
    class_type_name: 'Standard'
  },
  {
    class_type_id: '1004',
    class_type_name: 'Swatch'
  },
  {
    class_type_id: '1011',
    class_type_name: 'Top'
  }
];
